import { render } from "./ClassInfo.vue?vue&type=template&id=6b085286&scoped=true"
import script from "./ClassInfo.vue?vue&type=script&lang=js"
export * from "./ClassInfo.vue?vue&type=script&lang=js"

import "./ClassInfo.vue?vue&type=style&index=0&id=6b085286&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b085286"]])

export default __exports__